const formatNumber = (
  number: number | string,
  decimals: number = 2,
): string => {
  return Number(number).toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export default formatNumber;
